// AUTO GENERATED FILE - DO NOT EDIT
export default {
  account_switcher_logout_header_title: 'Log out',
  add_account_name_button_title: 'Add account name',
  confirm_logout_button_title: 'Confirm',
  default_account_title_label: 'Default account',
  edit_account_button_title: 'Edit account name',
  edit_account_name_back_button: 'Back',
  edit_account_quick_action_error_view_description: 'There was an error in updating your account name. Please go back to your accounts and try again.',
  edit_account_quick_action_error_view_title: 'Something went wrong',
  edit_account_quick_action_loading_view_title: 'Updating account name',
  edit_account_quick_action_save_button_title: 'Save account name',
  edit_account_quick_action_subtitle: 'What would you like to name it?',
  edit_account_quick_action_success_view_button_title: 'Return to your accounts',
  edit_account_quick_action_success_view_description: 'You have successfully named %1$s account.',
  edit_account_quick_action_success_view_title: 'Account name saved',
  edit_account_quick_action_title: 'Edit name',
  logout_back_button_title: 'Back',
  logout_description_text: 'Are you sure you want to log out from all your accounts?',
  make_default_account_title_label: 'Make it the default account',
  manage_account_header_title: 'Chose an action in your accounts',
  manage_account_screen_title: 'Manage accounts',
  remove_from_device_button_title: 'Remove from this device',
  alert_action_ok_button_title: 'OK',
  alert_warning_title: 'Warning',
  analytics_framework_campaign_internal_id_key: 'campaign_internal_id',
  analytics_framework_event_action_key: 'event_action',
  analytics_framework_event_action_onclick: 'OnClick',
  analytics_framework_event_category: 'OnClick',
  analytics_framework_event_category_key: 'event_category',
  analytics_framework_event_label_cancel: 'Cancel',
  analytics_framework_event_label_confirm: 'Confirm',
  analytics_framework_event_label_device_permissions: 'Device Permissions',
  analytics_framework_event_label_done: 'Done',
  analytics_framework_event_label_giga: 'Giga',
  analytics_framework_event_label_key: 'event_label',
  analytics_framework_event_label_onclick: 'OnClick',
  analytics_framework_event_label_read_terms: 'Read terms and conditions',
  analytics_framework_event_label_refer_more: 'Refer more action',
  analytics_framework_event_label_return_dashboard: 'Return to dashboard action',
  analytics_framework_event_label_share: 'Share',
  analytics_framework_event_label_try_again: 'Try Again',
  analytics_framework_event_name_key: 'event_name',
  analytics_framework_event_title: 'event',
  analytics_framework_event_title_ui_interaction: 'ui_interaction',
  analytics_framework_journey_type: 'Payment',
  analytics_framework_journey_type_app_settings: 'App Settings',
  analytics_framework_journey_type_key: 'journey_type',
  analytics_framework_journey_type_payment_methods: 'Payment Methods',
  analytics_framework_journey_type_product_and_services: 'Product and Services',
  analytics_framework_page_channel_key: 'page_channel',
  analytics_framework_page_error_key: 'page_error',
  analytics_framework_page_locale_key: 'page_locale',
  analytics_framework_page_name: 'Payment',
  analytics_framework_page_name_app_settings: 'App Settings',
  analytics_framework_page_name_device_permissions: 'Device Permissions',
  analytics_framework_page_name_key: 'page_name',
  analytics_framework_page_name_refer_a_friend: 'Refer A Friend',
  analytics_framework_page_name_refer_a_friend_success: 'Refer A Friend Success',
  analytics_framework_page_name_refer_a_friend_terms: 'Refer A Friend Terms',
  analytics_framework_page_section: 'Payment :Payment QA',
  analytics_framework_page_section_key: 'page_section',
  analytics_framework_page_view_key: 'page_view',
  analytics_framework_permissions_active: 'Permissions active',
  analytics_framework_permissions_pop_up: 'Permissions pop-up',
  analytics_framework_product_and_service_locale: 'en_GR',
  analytics_framework_product_and_service_page_channel: 'Vodafone.gr',
  analytics_framework_product_and_service_page_name: 'Products&Service',
  analytics_framework_product_and_service_page_section: 'Dashboard:Products&Service',
  analytics_framework_screen_title: 'QA / Payment',
  analytics_framework_screen_title_error: 'QA / Error',
  analytics_framework_screen_title_loading: 'QA / Loading status',
  analytics_framework_screen_title_success: 'QA / Success',
  analytics_framework_stories_campaign_internal_id: '12345',
  analytics_framework_stories_campaign_internal_medium: 'Story',
  analytics_framework_stories_campaign_internal_medium_key: 'campaign_internal_medium',
  analytics_framework_stories_campaign_internal_name: 'InApp Upgrade',
  analytics_framework_stories_campaign_internal_name_key: 'campaign_internal_name',
  analytics_framework_stories_campaign_internal_offer_detail: 'Vodafone broadband - Save 25%',
  analytics_framework_stories_campaign_internal_offer_detail_key: 'campaign_internal_offer_detail',
  analytics_framework_stories_campaign_internal_phase: 'awareness consideration purchase experience advocacy',
  analytics_framework_stories_campaign_internal_phase_key: 'campaign_internal_journey_phase',
  analytics_framework_stories_campaign_internal_type: 'personalisation',
  analytics_framework_stories_campaign_internal_type_key: 'campaign_internal_type',
  analytics_framework_stories_campaign_internal_visitor_type: 'customer',
  analytics_framework_stories_campaign_internal_visitor_type_key: 'campaign_internal_visitor_type',
  analytics_framework_stories_event_category: 'Card',
  analytics_framework_stories_event_label: 'Time for an upgrade!',
  analytics_framework_stories_journey_type: 'Discover',
  analytics_framework_stories_page_channel: 'Vodafone.gr',
  analytics_framework_stories_page_channel_key: 'page_channel',
  analytics_framework_stories_page_country: 'GR',
  analytics_framework_stories_page_country_key: 'page_country',
  analytics_framework_stories_page_locale: 'en_GR',
  analytics_framework_stories_page_locale_key: 'page_locale',
  analytics_framework_stories_page_name: 'Offer & rewards',
  analytics_framework_stories_page_section_value: 'Dashboard',
  analytics_framework_stories_visitor_addon_balance_usage_remaining_active_key: 'visitor_addon_balance_usage_remaining_active',
  analytics_framework_stories_visitor_asset_plan_id_active: '8211810',
  analytics_framework_stories_visitor_asset_plan_id_active_key: 'visitor_asset_plan_id_active',
  analytics_framework_stories_visitor_asset_plan_name_active: 'Unlimited Fibre 38',
  analytics_framework_stories_visitor_asset_plan_name_active_key: 'visitor_asset_plan_name_active',
  analytics_framework_stories_visitor_asset_plan_type_active_key: 'visitor_asset_plan_type_active',
  analytics_framework_stories_visitor_bill_amount_current_active_key: 'visitor_bill_amount_current_active',
  analytics_framework_stories_visitor_bill_date_due_current_active_key: 'visitor_bill_date_due_current_active',
  analytics_framework_stories_visitor_id_amcvid: 'a132fsde452fkjb423mn124lkn45nasdas',
  analytics_framework_stories_visitor_id_amcvid_key: 'visitor_id_amcvid',
  analytics_framework_stories_visitor_id_asset_active_key: 'visitor_id_asset_active',
  analytics_framework_stories_visitor_id_asset_list_key: 'visitor_id_asset_list',
  analytics_framework_stories_visitor_id_asset_primary_key: 'visitor_id_asset_primary',
  analytics_framework_sub_tray_payment_methods_title: 'sub_tray_payment_methods_title',
  analytics_framework_sub_tray_product_title: 'sub_tray_product_title',
  analytics_framework_transaction_status: 'Paid',
  analytics_framework_transaction_status_key: 'transaction_status',
  analytics_framework_view_title: 'View',
  analytics_framework_visitor_amount_current_active_key: 'visitor_amount_current_active',
  analytics_framework_visitor_bill_amount_current_active_key: 'visitor_bill_amount_current_active',
  analytics_framework_visitor_bill_date_due_current_active_key: 'visitor_bill_date_due_current_active',
  analytics_framework_visitor_login_status: 'logged in',
  analytics_framework_visitor_login_status_key: 'visitor_login_status',
  analytics_framework_visitor_permission_functional_disabled: 'disabled',
  analytics_framework_visitor_permission_functional_enabled: 'enabled',
  analytics_framework_visitor_permission_functional_key: 'visitor_permission_functional',
  analytics_framework_visitor_permission_name_key: 'visitor_permission_name',
  analytics_framework_visitor_permission_performance_key: 'visitor_permission_performance',
  analytics_framework_visitor_permission_targeting_enabled: 'enabled',
  analytics_framework_visitor_permission_targeting_key: 'visitor_permission_targeting',
  analytics_framework_visitor_permissions_key: 'visitor_permissions',
  book_appointment_confirm_appointment_button_title: 'Your appointments',
  book_appointment_confirm_calendar_button_title: 'Add to calendar',
  book_appointment_confirm_calendar_failure_title: 'Failed to add',
  book_appointment_confirm_calendar_success_title: 'Already added to calendar',
  book_appointment_confirm_subtitle: 'Your appointment is confirmed for:',
  book_appointment_confirm_title: 'Booking is successful!',
  book_appointment_date_available_slots: 'Available Slots',
  book_appointment_date_cta_button_title: 'Select date and time',
  book_appointment_date_format: 'EEEE \'%1$s\' \'of\' MMMM',
  book_appointment_date_step_subtile: 'Please choose a suitable time slot',
  book_appointment_date_step_title: 'Date',
  book_appointment_service_step_duration: 'Duration: %1$s',
  book_appointment_service_step_subtile: 'Which service are you looking for?',
  book_appointment_service_step_title: 'Service',
  book_appointment_store_cta_button_title: 'Show time slots',
  book_appointment_store_open_time_title: 'Open',
  book_appointment_store_step_title: 'Store',
  book_appointment_summary_cta_button_title: 'Confirm',
  book_appointment_summary_step_assistance: 'assistance',
  book_appointment_summary_step_privacy_hyperlink_text: 'return policy',
  book_appointment_summary_step_subtile: 'Your booking summary',
  book_appointment_summary_step_terms: 'By tapping ‘Confirm’ you accept our terms and conditions. See %1$s and %2$s.',
  book_appointment_summary_step_terms_hyperlink_text: 'terms and conditions',
  book_appointment_summary_step_title: 'Summary',
  book_appointments_requirements_card_title: 'Requirements',
  date_picker_days_friday: 'F',
  date_picker_days_monday: 'M',
  date_picker_days_saturday: 'S',
  date_picker_days_sunday: 'S',
  date_picker_days_thursday: 'T',
  date_picker_days_tuesday: 'T',
  date_picker_days_wednesday: 'W',
  your_appointments_book_button: 'Book an in-store appointment',
  your_appointments_cancel_booking_button: 'Cancel booking',
  your_appointments_change_booking_button: 'Change booking',
  your_appointments_get_store_directions_button: 'Get store direction',
  your_appointments_header_title: 'Upcoming',
  your_appointments_history_header_title: 'Booking history',
  your_appointments_history_no_appointment_title: 'You do not have any previous appointments',
  your_appointments_history_request_again_button: 'Request again',
  your_appointments_history_review_button: 'Review',
  your_appointments_no_appointment_description: 'Repairs, troubleshooting, information about new products, services or enterprise',
  your_appointments_no_appointment_subtitle: 'You can book an in-store appointment with one of our assistants to help with the following topics:',
  your_appointments_no_appointment_title: 'You do not have any upcoming appointments',
  your_appointments_screen_title: 'Your appointments',
  your_appointments_service_assistance: 'Assistance',
  auto_bill_date_filter_description: 'Your bill will automatically be paid on the selected day of every month. If this date does not fall within the month, your bill will be paid on the 1st of the next month.',
  auto_bill_date_filter_title: 'Choose automatic date of billing',
  auto_bill_quick_action_edit_loading: 'Editing auto bill payment…',
  auto_bill_quick_action_edit_title: 'Edit auto bill payment',
  auto_bill_quick_action_failure_cancel: 'Cancel',
  auto_bill_quick_action_failure_description: 'Unfortunately we were unable to process your request. Please try again.',
  auto_bill_quick_action_failure_title: 'Something went wrong!',
  auto_bill_quick_action_failure_try_again: 'Try again',
  auto_bill_quick_action_loading: 'Setting up auto bill payment…',
  auto_bill_quick_action_primary_button_text: 'Confirm',
  auto_bill_quick_action_secondary_button_text: 'Cancel',
  auto_bill_quick_action_successful_description: 'Your auto bill payment has been set up successfully. Your next bill will be paid on the %1$s of %2$s.',
  auto_bill_quick_action_successful_primary_button_text: 'Done',
  auto_bill_quick_action_successful_title: 'Congratulations!',
  pay_bill_quick_action_close_button_text: 'Cancel',
  pay_bill_quick_action_confirm_button_text: 'Confirm',
  pay_bill_quick_action_edit: 'Edit',
  pay_bill_quick_action_failure_cancel: 'Cancel',
  pay_bill_quick_action_failure_description: 'Unfortunately we were unable to process your request. Please review your payment details.',
  pay_bill_quick_action_failure_title: 'Something went wrong!',
  pay_bill_quick_action_failure_try_again: 'Try again',
  pay_bill_quick_action_loading_main: 'Paying bill…',
  pay_bill_quick_action_main_title: 'Pay %1$@ bill',
  pay_bill_quick_action_payment_method_title: 'Payment method',
  pay_bill_quick_action_subtitle: 'Total amount to pay:',
  pay_bill_quick_action_successful: '%1$@ bill is paid!',
  pay_bill_quick_action_successful_button_title: 'Done',
  pay_bill_quick_action_successful_description: 'The payment of the bill has been completed successfully.',
  payment_add_card_loading_text: 'Processing…',
  payment_add_form_card_name: 'Name this card',
  payment_add_form_card_name_error_message: 'Helper Text',
  payment_add_form_card_number: 'Card number',
  payment_add_form_card_number_error_message: 'Invalid card number',
  payment_add_form_cvv_number: 'CVV',
  payment_add_form_cvv_number_error_message: 'Invalid CVV number',
  payment_add_form_description_toggle: 'You’ll be no longer able to use this card in the app.',
  payment_add_form_expiration_date: 'Expiry date',
  payment_add_form_expiration_date_error_message: 'Invalid date',
  payment_add_form_expiration_date_hint_message: 'MM/YY',
  payment_add_form_name_on_card: 'Name on card',
  payment_add_form_name_on_card_error_message: 'Helper Text',
  payment_add_form_save_button: 'Save card',
  payment_add_form_security_notice: 'This is a secure SSL encrypted channel. Your card details are associated with your VodafoneID.',
  payment_add_form_title_toggle: 'Delete %1$s?',
  payment_add_form_toggle_text: 'Save card for later use',
  payment_add_new_card_screen_title: 'Add new card',
  payment_add_new_payment_method: 'Add new card',
  payment_add_scan_card_description: 'You can easily add your card details by scanning it with your phone camera',
  payment_delete_form_delete_button: 'Delete card',
  payment_delete_form_keep_card_button: 'Keep card',
  payment_edit_scan_card_description: 'You can easily edit your card details by scanning it with your phone camera',
  payment_expiry_date: 'expiry date',
  payment_make_payment_method_preferred: 'Make preferred',
  payment_method_add_card: 'Add New Card',
  payment_method_add_card_title: 'Add new credit/debit card',
  payment_method_expiry: 'Exp %1$s',
  payment_method_nfc_payment: 'NFC payment',
  payment_method_nfc_payment_screen_button_text: 'Back',
  payment_method_nfc_payment_screen_content: 'Please place your card on the NFC spot',
  payment_method_nfc_payment_screen_title: 'Pay with NFC',
  payment_method_screen_title: 'Payment',
  payment_no_existing_methods_description: 'You can add your credit/debit card information by tapping on the Add new card button.',
  payment_no_existing_methods_title: 'There are no existing payment methods.',
  payment_other_payment_methods: 'Other payments',
  payment_preferred_payment_methods: 'Preferred payment',
  top_up_quick_action_payment_method: '%1$s ending **** %2$s',
  top_up_quick_action_payment_method_subtitle: '%1$s **** %2$s',
  broadband_offer_book_engineer_subtitle: 'Please choose a suitable date and time for one of our engineers to come and install your new broadband.',
  broadband_offer_delivery_address_options_button: 'Address options',
  broadband_offer_delivery_address_title: 'Delivery address',
  broadband_offer_delivery_options_title: 'Delivery options',
  broadband_offer_header_date: 'Offer valid until %1$s',
  broadband_offer_header_price_text: 'per month',
  broadband_offer_installation_step_button_title: 'Continue to next step',
  broadband_offer_installation_step_subtitle: 'Select an option to install your router',
  broadband_offer_installation_step_title: 'Installation',
  broadband_offer_plan_card_subscriptions_title: 'Plus one of these subscriptions for free',
  broadband_offer_plans_button_text: 'Compare plans',
  broadband_offer_plans_title: 'Your offer',
  broadband_offer_plans_why_this_plan_modal_button: 'Close',
  broadband_offer_plans_why_this_plan_modal_content: 'Based on your average usage of %1$s per month this year we think this plan is best suited for you.',
  broadband_offer_plans_why_this_plan_modal_question: 'Why this plan is perfect for me?',
  broadband_offer_plans_why_this_plan_modal_title: 'Recommended for you',
  broadband_offer_store_location_button_text: 'Edit',
  broadband_offer_store_location_header_text: 'Pick up location',
  broadband_offer_store_location_openning_times: 'Opening times',
  broadband_offer_store_location_subtitle: 'Step free access to store',
  broadband_offer_summary_step_confirm_success_button_title: 'Go Back to dashboard',
  broadband_offer_summary_step_confirm_success_first_subtitle: 'Your order is being processed.',
  broadband_offer_summary_step_confirm_success_second_subtitle: 'We will be in touch soon with confirmation and next steps. Your router will be with you in the next %1$s',
  broadband_offer_summary_step_confirm_success_title: 'Congratulations!',
  broadband_offer_summary_step_cta_button_title: 'Confirm',
  broadband_offer_summary_step_my_new_plan: 'My new plan',
  broadband_offer_summary_step_privacy_hyperlink_text: 'return policy',
  broadband_offer_summary_step_see_terms: 'See %1$s and %2$s.',
  broadband_offer_summary_step_summary: 'Summary',
  broadband_offer_summary_step_terms_hyperlink_text: 'terms and conditions',
  broadband_offer_summary_step_terms_note: 'By tapping ‘Confirm’ you accept our terms and conditions.',
  broadband_offer_summary_step_title: 'Summary',
  broadband_offer_summary_step_total_cost_current_plan_monthly: 'Current plan monthly cost',
  broadband_offer_summary_step_total_cost_duration: 'Duration',
  broadband_offer_summary_step_total_cost_duration_value: '%1$s months',
  broadband_offer_summary_step_total_cost_first_bill: 'First bill',
  broadband_offer_summary_step_total_cost_first_bill_why: 'Why?',
  broadband_offer_summary_step_total_cost_first_bill_why_modal_button_title: 'Close',
  broadband_offer_summary_step_total_cost_first_bill_why_modal_description: 'Your first bill amount may be higher because it includes upfront device and accessories costs.',
  broadband_offer_summary_step_total_cost_first_bill_why_modal_question: 'Why %1$s on your first bill?',
  broadband_offer_summary_step_total_cost_first_bill_why_modal_title: 'Total cost',
  broadband_offer_summary_step_total_cost_new_plan_monthly: 'New plan monthly cost',
  broadband_offer_summary_step_total_cost_next_bill: 'Next bill',
  broadband_offer_summary_step_total_cost_note: 'This price will be added to your next bill',
  broadband_offer_summary_step_total_cost_per_month: 'per month',
  broadband_offer_summary_step_total_cost_start_date: 'Start date',
  broadband_offer_summary_step_total_cost_title: 'Total cost',
  change_password_at_least_five_characters: 'At least 5 characters',
  change_password_confirm_button_title: 'Confirm',
  change_password_confirm_new_password_error_message: 'Password doesn\'t match',
  change_password_confirm_new_password_placeholder: 'Confirm new password',
  change_password_current_password_placeholder: 'Enter current password',
  change_password_description: 'For security reasons enter your current password',
  change_password_forget_password_button_title: 'I forgot my password',
  change_password_modal_failure_button_title: 'Try again',
  change_password_modal_failure_subtitle: 'Your password has not been changed. Try again.',
  change_password_modal_failure_title: 'Something went wrong',
  change_password_modal_success_button_title: 'Go to dashboard',
  change_password_modal_success_subtitle: 'Your password has been successfully changed.',
  change_password_modal_success_title: 'Congratulations!',
  change_password_modal_title: 'Change password',
  change_password_new_password_placeholder: 'Enter new password',
  change_password_new_password_title: 'Select your new password',
  change_password_strength_normal_title: 'Normal',
  change_password_strength_strong_title: 'Strong',
  change_password_strength_title: 'Strength',
  change_password_strength_weak_title: 'Weak',
  change_password_subtitle: 'Change password',
  change_password_title: 'My password',
  app_error_button: 'Retry',
  app_error_description: 'Your connection was interrupted or your network has changed, your device may be trying to connect to too many networks at once.',
  app_error_title: 'An error has occurred',
  app_name: 'My Vodafone',
  biometric_toggle_subtitle: 'Use Biometrics to easily access My Vodafone with your Phone.',
  biometric_toggle_title: 'Touch ID',
  dashboard_app_get_action_label: 'Get',
  dashboard_app_open_action_label: 'Open',
  dashboard_apps_component_title: 'Other Vodafone apps',
  dashboard_assistance_group_component_name: 'Assistance',
  dashboard_basic_group_component_name: 'Basics',
  dashboard_broadband_finder_item_title: 'Broadband finder',
  dashboard_change_pin_item_title: 'Change PIN',
  dashboard_demo_component_name: 'Demo Component',
  dashboard_demo_component_title: 'This is our demo component',
  dashboard_developer_settings_item_title: 'Developer settings',
  dashboard_discover_section_see_all_text: 'See all',
  dashboard_discovery_label: 'Discover',
  dashboard_entertainment_component_subtitle: 'Find out more',
  dashboard_entertainment_component_title: 'Explore our amazing entertainment services!',
  dashboard_facebook_item_title: 'Facebook',
  dashboard_group_component_show_less: 'Show less',
  dashboard_group_component_show_more: 'Show more',
  dashboard_header_logged_in_subtitle: 'See account',
  dashboard_header_logged_in_title: 'Hey, %1$s',
  dashboard_header_non_logged_in_subtitle: 'Log in or create an account',
  dashboard_header_non_logged_in_title: 'Good morning',
  dashboard_help_and_support_item_title: 'Help and support',
  dashboard_highlights_title: 'Highlights',
  dashboard_in_store_appointment_item_title: 'In-store appointments',
  dashboard_item_error_normal_message: 'An error has occurred',
  dashboard_item_error_normal_try_again_button: 'Try again',
  dashboard_item_error_small_message: 'Error occurred',
  dashboard_item_error_small_try_again_button: 'Try again',
  dashboard_item_secure_content_subtitle: 'Tap to access this secure area',
  dashboard_loading_error_message: 'An error has occurred and we\'re having some trouble loading your content.',
  dashboard_loading_error_try_again_button: 'Try again',
  dashboard_my_messages_card_title: 'My messages',
  dashboard_network_health_group_component_name: 'Network Health',
  dashboard_offers_rewards_group_component_name: 'Offers and rewards',
  dashboard_product_selector_error_message: 'Sorry, your products & services could not be loaded',
  dashboard_product_specific_cards_title: 'Marketplace',
  dashboard_product_switcher_error_message: 'Sorry, your products & services could not be loaded',
  dashboard_purchase_add_on_item_title: 'Purchase add on',
  dashboard_refer_a_friend_item_title: 'Refer a friend',
  dashboard_seasonal_offers_countdown_days: 'days',
  dashboard_seasonal_offers_countdown_hours: 'hrs',
  dashboard_seasonal_offers_countdown_minutes: 'mins',
  dashboard_seasonal_offers_countdown_seconds: 'secs',
  dashboard_slack_item_title: 'Slack',
  dashboard_speed_checker_title: 'Speed Checker',
  dashboard_store_locator_item_title: 'Store locator',
  dashboard_super_app_category_error_message: 'Sorry, looks like an error has occurred',
  dashboard_super_app_more_cateogry_label: 'More categories',
  dashboard_title: 'Dashboard',
  dashboard_travelling_abroad_item_title: 'Travelling abroad',
  dashboard_twitter_item_title: 'Twitter',
  dashboard_upgrade_component_button_topup: 'Top-up now',
  dashboard_upgrade_component_name: 'upgrade component',
  dashboard_upgrade_component_subtitle_topup: 'Normal price %1$s%2$s.\nOffer ends on %3$s.',
  dashboard_upgrade_component_title: 'This is upgrade component',
  dashboard_upgrade_component_title_topup: '%1$s, top up by %2$s%3$s or more and get %4$s%5$s data for %6$s%7$s',
  dashboard_wifi_finder_item_title: 'WiFi finder',
  dashboard_your_messages_item_title: 'Your messages',
  display_options_display_mode_section_description: 'This mode is using your system settings.',
  display_options_display_mode_section_title: 'Display mode',
  display_options_mode_auto: 'Auto',
  display_options_mode_dark: 'Dark',
  display_options_mode_light: 'Light',
  display_options_mode_select_subtitle: 'Select your preferred mode:',
  edit_tertiary_tiles_confirm_cta_button_title: 'Confirm',
  edit_tertiary_tiles_hidden_section_title: 'Hidden tiles',
  edit_tertiary_tiles_subtitle: 'You can rearrange the order of the tiles by pressing down a tile and dragging it up and down. Only two tiles can be displayed on the dashboard.',
  edit_tertiary_tiles_title: 'Customise the small tiles',
  edit_tertiary_tiles_visible_section_title: 'Displayed dashboard tiles',
  edit_usage_cards_confirm_cta_button_title: 'Confirm',
  edit_usage_cards_hidden_section_title: 'More tiles',
  edit_usage_cards_screen_title: 'Dashboard settings',
  edit_usage_cards_subtitle: 'You can rearrange the tiles by adding, removing or pressing down a tile and dragging it up and down.',
  edit_usage_cards_success_overlay_subtitle: 'Your dashboard tile has been successfully updated.',
  edit_usage_cards_success_overlay_title: 'Congratulations!',
  edit_usage_cards_title: 'Customize the main tile',
  edit_usage_cards_visible_section_title: 'Displayed dashboard tiles',
  everything_is_ok_account_title: 'Account',
  everything_is_ok_additional_charges_action_title: 'Review',
  everything_is_ok_additional_charges_description: 'You have %1$s out of plan spend on your current bill. Please review these charges.',
  everything_is_ok_additional_charges_title: 'Additional charges',
  everything_is_ok_address_up_to_date_title: 'Address up to date',
  everything_is_ok_billing_title: 'Billing',
  everything_is_ok_broadband_title: 'Broadband',
  everything_is_ok_data_remaining_title: 'Data Remaining',
  everything_is_ok_description_text: 'Just checking everything is OK',
  everything_is_ok_details_screen_error_text: 'We\'ve found something that you need to have a look at…',
  everything_is_ok_details_screen_in_progress_text: 'We\'re checking your services. This won\'t take long.',
  everything_is_ok_details_screen_success_text: 'Everything is OK, %1$s. We\'ll let you know if anything changes.',
  everything_is_ok_error_text: 'We\'ve found an issue…',
  everything_is_ok_greeting_text: 'Good morning %1$s',
  everything_is_ok_in_progress_text: 'Checking your services…',
  everything_is_ok_last_bill_paid_description: 'Okay',
  everything_is_ok_last_bill_paid_title: 'Last bill paid',
  everything_is_ok_my_phone_title: 'My phone',
  everything_is_ok_payment_details_action_title: 'Update',
  everything_is_ok_payment_details_description: 'Your payment details are out of date.',
  everything_is_ok_payment_details_title: 'Payment Details',
  everything_is_ok_phone_title: '%1$s\'s phone',
  everything_is_ok_speed_checker_action: 'Speed Checker',
  everything_is_ok_text: 'Everything is OK',
  lastupdatedlabel_justupdated: 'Updated now',
  lastupdatedlabel_minute: '%1$smin since last update',
  lastupdatedlabel_minutes: '%1$smin since last update',
  lastupdatedlabel_timestamp: 'Last updated %1$s',
  lastupdatedlabel_updating: 'Updating…',
  logout_button: 'Log out',
  logout_cancel_button: 'Cancel',
  logout_description: 'Are you sure you want to log out of My Vodafone?',
  logout_subtitle: '%1$s\'s account',
  logout_title: 'Log out',
  multiple_account_banner_message: 'Signed-in as %1$@',
  mva10_layout_title: 'My Vodafone',
  pullrefresh_pulldown: 'Pull down to refresh',
  pullrefresh_release: 'Release to refresh',
  pullrefresh_updated: 'Updated',
  pullrefresh_updating: 'Checking for new updates',
  settings_app_settings: 'App settings',
  settings_dashboard_settings_customise_main_tile: 'Customise the main tile',
  settings_dashboard_settings_customise_small_tile: 'Customise the small tiles',
  settings_dashboard_settings_subtitle: 'Customise what you want to see on the dashboard.',
  settings_dashboard_settings_title: 'Dashboard settings',
  settings_device_permissions_subtitle: 'Customize which permissions you give access to certain apps.',
  settings_device_permissions_title: 'Device permissions',
  settings_language_settings_subtitle: 'Select the language you prefer for MVA10',
  settings_language_settings_title: 'Language',
  story_countdown_expire_offer_time: 'Offer expires in %1$s',
  story_countdown_hour: 'h',
  story_countdown_minute: 'm',
  story_offer_expired: 'Offer expired',
  sub_tray_error_title: 'An error has occurred. We could not load your %1$s',
  super_app_category_overlay_label: 'More categories',
  tray_messages_section_subtitle: 'No new messages',
  tray_messages_section_subtitle_with_badge: '%1$s unread messages',
  usage_card_edit_tiles_title: 'Edit tiles',
  usage_card_out_of_total: 'left of your %1$s bundle',
  usage_card_resets_in_day: 'Resets in %1$s day',
  usage_card_resets_in_days: 'Resets in %1$s days',
  usage_card_unlimited_title: 'Unlimited',
  device_upgrade_choose_step_cta_button_title: 'Choose',
  device_upgrade_choose_step_header: 'Choose a device',
  device_upgrade_choose_step_price_from: 'From',
  device_upgrade_choose_step_price_per_month: 'month',
  device_upgrade_choose_step_price_upfront: 'Upfront',
  device_upgrade_choose_step_selected: 'Selected',
  device_upgrade_choose_step_title: 'Choose',
  device_upgrade_cost_breakdown_modal_footer_description: 'Get more out of your plan by adding broadband.',
  device_upgrade_cost_breakdown_modal_footer_primary_button_title: 'View offer',
  device_upgrade_cost_breakdown_modal_footer_secondary_button_title: 'Not now',
  device_upgrade_cost_breakdown_modal_footer_title: 'Add broadband to save monthly',
  device_upgrade_cost_breakdown_modal_title: 'Cost breakdown',
  device_upgrade_device_step_collection_and_delivery: 'Collection and delivery',
  device_upgrade_device_step_cta_button_title: 'Continue to next step',
  device_upgrade_device_step_device_overview: 'Device overview',
  device_upgrade_device_step_free: 'Free',
  device_upgrade_device_step_in_box: 'What\'s in the box',
  device_upgrade_device_step_more_information: 'More Information',
  device_upgrade_device_step_select_capacity: 'Select capacity',
  device_upgrade_device_step_select_colour: 'Select colour',
  device_upgrade_device_step_selected: 'Selected',
  device_upgrade_device_step_show_full_specifications_button_title: 'Show full specification',
  device_upgrade_device_step_show_full_specifications_screen_title: 'Full specifications',
  device_upgrade_device_step_specifications: 'Specifications',
  device_upgrade_device_step_title: 'Device',
  device_upgrade_header_contract_type_text: 'months contract',
  device_upgrade_header_cost_breakdown_button_title: 'Cost breakdown',
  device_upgrade_header_recuring_price_text_monthly: 'monthly',
  device_upgrade_header_upfront_price_text: 'upfront',
  device_upgrade_plan_screen_my_plan_title: 'My current plan',
  device_upgrade_plan_screen_other_plans_title: 'Other plans',
  device_upgrade_plan_screen_plan_card_subscriptions_title: 'Plus one of these subscriptions for free',
  device_upgrade_plan_screen_plan_card_why_this_plan_title: 'Why this plan is perfect for me?',
  device_upgrade_plan_screen_title: 'Choose a plan',
  device_upgrade_plan_step_cta_button_title: 'Choose this plan',
  device_upgrade_plan_step_title: 'Plan',
  device_upgrade_recommended_title: 'Recommended for you',
  device_upgrade_screen_title: 'Upgrade',
  device_upgrade_summary_confirm_failure_button_title: 'Back to summary',
  device_upgrade_summary_confirm_failure_first_subtitle: 'An error has occurred.',
  device_upgrade_summary_confirm_failure_second_subtitle: 'Please try again later.',
  device_upgrade_summary_confirm_failure_title: 'Oops&#x0002C there\'s a problem!',
  device_upgrade_summary_confirm_success_button_title: 'Back to dashboard',
  device_upgrade_summary_confirm_success_first_subtitle: 'You have upgraded your plan to %1$s and your new %2$s will be delivered %3$s!',
  device_upgrade_summary_confirm_success_second_subtitle: 'Keep an eye on your dashboard to track your delivery.',
  device_upgrade_summary_confirm_success_title: 'Congratulations, %1$s',
  device_upgrade_summary_step_cta_button_title: 'Confirm',
  device_upgrade_summary_step_delivery_address: 'Delivery address',
  device_upgrade_summary_step_delivery_option_home_delivery: 'Home Delivery',
  device_upgrade_summary_step_delivery_options: 'Delivery options',
  device_upgrade_summary_step_device_capacity: 'capacity',
  device_upgrade_summary_step_edit: 'Edit',
  device_upgrade_summary_step_my_new_device: 'My new device',
  device_upgrade_summary_step_my_new_plan: 'My new plan',
  device_upgrade_summary_step_my_upgrade_selection: 'My upgrade selection',
  device_upgrade_summary_step_payment_and_delivery: 'Payment and delivery',
  device_upgrade_summary_step_payment_card_ending: 'Ending',
  device_upgrade_summary_step_payment_method: 'Payment method',
  device_upgrade_summary_step_privacy_hyperlink_text: 'return policy',
  device_upgrade_summary_step_see_terms: 'See %1$s and %2$s.',
  device_upgrade_summary_step_terms_hyperlink_text: 'terms and conditions',
  device_upgrade_summary_step_terms_note: 'By tapping ‘Confirm’ you accept our terms and conditions.',
  device_upgrade_summary_step_title: 'Summary',
  device_upgrade_summary_step_total_cost_breakdown: 'Breakdown',
  device_upgrade_summary_step_total_cost_device_monthly: 'Monthly over %1$s months',
  device_upgrade_summary_step_total_cost_device_total_cost: 'Total device cost:',
  device_upgrade_summary_step_total_cost_device_upfront: 'Upfront',
  device_upgrade_summary_step_total_cost_duration: 'Duration',
  device_upgrade_summary_step_total_cost_duration_value: '%1$s months',
  device_upgrade_summary_step_total_cost_first_bill: 'First bill',
  device_upgrade_summary_step_total_cost_first_bill_why: 'Why?',
  device_upgrade_summary_step_total_cost_first_bill_why_modal_button_title: 'Close',
  device_upgrade_summary_step_total_cost_first_bill_why_modal_description: 'Your first bill amount may be higher because it includes upfront device and accessories costs.',
  device_upgrade_summary_step_total_cost_first_bill_why_modal_question: 'Why %1$s on your first bill?',
  device_upgrade_summary_step_total_cost_first_bill_why_modal_title: 'Total cost',
  device_upgrade_summary_step_total_cost_monthly: 'monthly',
  device_upgrade_summary_step_total_cost_new_plan_monthly: 'Monthly over %1$s months',
  device_upgrade_summary_step_total_cost_note: 'This price will be added to your next bill',
  device_upgrade_summary_step_total_cost_start_date: 'Start date',
  device_upgrade_summary_step_total_cost_title: 'Total cost',
  device_upgrade_summary_step_total_cost_total_to_pay: 'Total to pay',
  device_upgrade_summary_step_total_cost_total_to_pay_monthly: 'Monthly (over %1$s months)',
  device_upgrade_summary_step_total_cost_total_to_pay_upfront: 'Upfront',
  device_upgrade_summary_step_total_cost_upfront: 'upfront',
  device_upgrade_summary_step_total_cost_your_new_plan: 'Your new plan',
  device_upgrade_summary_step_total_cost_your_upgrade_selection: 'Your upgrade selection',
  eshop_name_business: 'Business',
  eshop_name_devices: 'Connected Devices',
  eshop_name_fiber_and_leisure: 'Fiber Broadband and Leisure',
  eshop_name_flex: 'Flex',
  eshop_name_leisure: 'Leisure',
  eshop_name_mobile: 'Mobile Phones',
  eshop_name_services: 'Services',
  quick_links_title: 'Quick links',
  change_address_city_selection_cancel_button_title: 'Cancel',
  change_address_city_selection_done_button_title: 'Done',
  change_address_country_selection_cancel_button_title: 'Cancel',
  change_address_country_selection_done_button_title: 'Done',
  change_address_form_city_label: 'City',
  change_address_form_country_label: 'Country',
  change_address_form_house_or_number_label: 'House / Flat number',
  change_address_form_postcode_label: 'Postcode',
  change_address_form_street_name_label: 'Street name',
  change_address_modal_failure_button_title: 'Try again',
  change_address_modal_failure_subtitle: 'Your address has not been saved. Try again.',
  change_address_modal_failure_title: 'Something went wrong',
  change_address_modal_success_button_title: 'Go to dashboard',
  change_address_modal_success_subtitle: 'Your address has been successfully changed.',
  change_address_modal_success_title: 'Congratulations!',
  change_address_modal_title: 'Change address',
  change_address_save_button: 'Save new address',
  change_address_screen_title: 'Change address',
  change_address_subtitle: 'Add the details of your new address',
  change_address_title: 'Add new address',
  delete_address_modal_failure_button_title: 'Try again',
  delete_address_modal_failure_subtitle: 'Your address has not been deleted. Try again.',
  delete_address_modal_failure_title: 'Something went wrong',
  delete_address_modal_success_button_title: 'Go to dashboard',
  delete_address_modal_success_subtitle: 'Your address has been successfully deleted.',
  delete_address_modal_success_title: 'Congratulations!',
  delete_address_quick_action_cancel_button_text: 'Cancel',
  delete_address_quick_action_confirm_button_text: 'Confirm',
  delete_address_quick_action_header: 'Delete address',
  delete_address_quick_action_subtitle: 'You will not be able to restore deleted address',
  delete_address_quick_action_title: 'Are you sure you want to delete this address?',
  my_address_button_title: 'Change address',
  my_address_correspondence_title: 'Correspondence address',
  my_address_current_subtitle: 'We\'ll use this address to send your correspondence',
  my_address_current_title: 'Current address',
  my_address_delete_button_title: 'Delete',
  my_address_edit_button_title: 'Edit',
  my_address_screen_title: 'My addresses',
  my_orders_action_edit: 'Edit',
  my_orders_action_order_summary: 'Order summary',
  my_orders_date_cancelled: 'Date cancelled: %1$s',
  my_orders_date_completed: 'Date completed: %1$s',
  my_orders_empty_subtitle: 'We will notify you when there is a new update.',
  my_orders_empty_title: 'You don’t have any order in progress',
  my_orders_estimated_delivery: 'Est. delivery:',
  my_orders_inprogress: 'In progress',
  my_orders_installation: 'Installation:',
  my_orders_last_updated_title: 'Last updated %1$s at %2$s',
  my_orders_manage_your_orders: 'Manage your orders',
  my_orders_no_available_orders: 'No orders in progress',
  my_orders_number_of_orders_inprogress: '%1$s order in progress',
  my_orders_order_number: 'Order number:',
  my_orders_order_placed_title: 'Order placed: %1$s',
  my_orders_pastorders: 'Past orders',
  my_orders_status: 'Status:',
  my_orders_summary_total_device_cost: 'Total device cost:',
  my_orders_summary_total_to_pay: 'Total to pay',
  my_orders_summary_total_to_pay_monthly: 'Monthly over %1$s months',
  my_orders_summary_total_to_pay_monthly_total: 'Monthly (over %1$s months)',
  my_orders_summary_upfront: 'Upfront',
  my_orders_title: 'My orders',
  my_orders_today: 'today',
  order_progress_alert_button: 'Get progress alerts',
  order_progress_cancelled_status: 'Cancelled',
  order_progress_collection_status: 'Ready for collection',
  order_progress_completed_status: 'Completed',
  order_progress_confirmed_status: 'Confirmed',
  order_progress_delivered_status: 'Delivered',
  order_progress_dispatched_status: 'Dispatched',
  order_progress_estimated_delivery: 'Estimated delivery: %1$s',
  order_progress_installation_status: 'Installation',
  order_progress_screen_title: 'Order no. %1$s',
  order_progress_status: 'Status: %1$s',
  order_progress_timeline_action: 'View order details',
  order_progress_timeline_collection_title: 'Ready for collection',
  order_progress_timeline_confirmed_title: 'Order confirmed',
  order_progress_timeline_delivered_title: 'Order delivered',
  order_progress_timeline_dispatched_title: 'Order dispatched',
  order_progress_timeline_installation_title: 'Installation',
  order_progress_timeline_step_update_time: 'Update time:',
  order_progress_timeline_subtitle: 'Order placed: %1$s',
  order_progress_timeline_title: 'Order updates',
  order_progress_timeline_transit_title: 'Order in transit',
  order_progress_transit_status: 'In transit',
  payment_method_options_title: 'How do you want to top-up?',
  payment_quick_action_confirm_button_text: 'Confirm',
  payment_quick_action_failure_description: 'Your transaction could not be completed',
  payment_quick_action_loading: 'Paying bill…',
  payment_quick_action_reject_button_text: 'Cancel',
  payment_quick_action_subtitle: 'Total amount to pay:',
  payment_quick_action_success: '%1$s bill is paid!',
  payment_quick_action_success_message: 'The payment of the bill has been completed successfully.',
  payment_quick_action_title: 'Pay %1$s bill',
  payment_quick_action_title_done_button_text: 'Done',
  payment_quick_action_title_ok_button_text: 'OK',
  payment_scan_card_button: 'Scan card',
  picker_select_cancel_text: 'Cancel',
  picker_select_done_text: 'Done',
  quick_action_payment_method_edit: 'Edit',
  quick_action_selected_payment_method_desc: '**** **** **** %1$s',
  voucher_top_up_confirm_code_cta: 'Top-up',
  app_permissions_status_blocked: 'OFF',
  app_permissions_status_granted: 'ON',
  background_location_overlay_allow_all_the_time_label: '‘Allow all the time’',
  background_location_overlay_description: 'Allow us to access your location even when the app is not being used so we can detect coverage dead zones and improve connection quality.',
  background_location_overlay_details_allow_all_the_time_label: '‘Allow all the time’',
  background_location_overlay_details_description: 'We analyse the collected and anonymised information which helps us detect where we can improve your network quality.',
  background_location_overlay_details_first_hint: 'We do not collect any personal data',
  background_location_overlay_details_go_to_settings_button_text: 'Go to Settings',
  background_location_overlay_details_go_to_settings_label: 'Go to Settings and tap:',
  background_location_overlay_details_how_to_turn_on: 'How to turn on location services',
  background_location_overlay_details_privacy_policy_label: 'See our privacy policy',
  background_location_overlay_details_second_hint: 'This function will not drain your battery',
  background_location_overlay_details_third_hint: 'Your communications will not be accessed',
  background_location_overlay_details_title: 'How it works',
  background_location_overlay_first_hint: 'We do not collect any personal data',
  background_location_overlay_go_to_settings_button_text: 'Go to Settings',
  background_location_overlay_go_to_settings_label: 'Go to Settings and tap:',
  background_location_overlay_learn_more: 'Learn more',
  background_location_overlay_not_now_button_text: 'Not now',
  background_location_overlay_second_hint: 'This function will not drain your battery',
  background_location_overlay_title: 'Help us improve your network',
  improving_our_network_description: 'Dependent on the level of access you have given us, we may collect data including location, performance & installed apps that can use to improve our service. This data will not be linked back to you in any way.',
  improving_our_network_title: 'Network',
  permissions_app_personalised_description: 'Dependent on the level of access you have given us, we may make recommendations and tailor our service based on your location, quality of your connectivity service & installed apps data consumption.',
  permissions_app_personalised_title: 'Personalised services and recommendations',
  permissions_button_title: 'I am happy with this',
  permissions_contact_description: 'Sync photos and names from your address book directly to numbers and devices to your account',
  permissions_contact_title: 'Contact Book',
  permissions_contacts_card_button_title: 'Give permission',
  permissions_contacts_card_description: 'To display your contacts here, My Vodafone needs permission to access your contacts.',
  permissions_contacts_card_title: 'Your contact list',
  permissions_footer_text: 'To manage the level of access Vodafone App has on your device tap',
  permissions_header_title: 'You can change these from your Settings screen later.',
  permissions_location_description: 'To show you messages and important information based on your location.',
  permissions_location_title: 'Location',
  permissions_network_description: 'Use the data collected to help improve our network which won\'t be linked back to you in any way',
  permissions_network_title: 'Network',
  permissions_personalised_description: 'Use data which identifies you to provide you with personalised services and recommendations',
  permissions_personalised_title: 'Personalised services and recommendations',
  permissions_push_notifications_description: 'Let us keep you up to date with important notifications about your account',
  permissions_push_notifications_title: 'Push Notifications',
  permissions_request_hypertext: 'Tap here to turn on',
  permissions_settings_hypertext: 'Settings',
  permissions_step_title: 'Permissions for improved experience',
  personal_advisor_confirm_button_title: 'Send New Request',
  personal_advisor_customer_title: 'Customer representative',
  personal_advisor_decription_max_limit: 'You have reached the characters limit.',
  personal_advisor_decription_placeholder: 'Describe your issue here',
  personal_advisor_decription_tip_label: 'Max Length',
  personal_advisor_info_label: 'Fill in the request details below and your personal advisor will get back to your shortly.',
  personal_advisor_phonenumber_textfield_placeholder: 'Mobile Number',
  personal_advisor_phonenumber_tip_label: 'Mobile Number',
  personal_advisor_phonenumber_title: 'Your advisor will contact you on this number',
  personal_advisor_previous_status_completed_desc: 'Your personal advisor has contacted with you about your last request.If you need any further assistance please send a new request.',
  personal_advisor_previous_status_completed_primary_title: 'Close',
  personal_advisor_previous_status_completed_title: 'Status: Completed',
  personal_advisor_previous_status_failed_desc: 'Something went wrong',
  personal_advisor_previous_status_failed_primary_title: 'Try again',
  personal_advisor_previous_status_failed_secondary_title: 'Close',
  personal_advisor_previous_status_sent_desc: 'Your last request has been sent. Your personal advisor will contact you shortly.',
  personal_advisor_previous_status_sent_failed_title: 'Something went wrong',
  personal_advisor_previous_status_sent_primary_title: 'Close',
  personal_advisor_previous_status_sent_title: 'Status: Sent',
  personal_advisor_previous_status_title: 'Tell us how we can help',
  personal_advisor_sent_request_cancel_title: 'Close',
  personal_advisor_sent_request_failure_button_title: 'Try again',
  personal_advisor_sent_request_failure_subtitle: 'Something went wrong',
  personal_advisor_sent_request_failure_title: 'Something went wrong',
  personal_advisor_sent_request_success_button_title: 'Back to home page',
  personal_advisor_sent_request_success_subtitle: 'Your personal advisor will look into your request and contact you shortly.',
  personal_advisor_sent_request_success_title: 'Request sent!',
  personal_advisor_sent_request_title: 'Tell us how we can help',
  personal_advisor_status_request_button_title: 'Check previous request status',
  personal_advisor_subtitle: 'Personal Advisor',
  tutorial_primary_button_text: 'Login',
  tutorial_secondary_button_text: 'Register',
  tutorial_step1_description: 'Tap on account in the menu to access your messages and take full control over your account',
  tutorial_step1_title: 'Your account in your hands',
  tutorial_step2_description: 'Easily manage your current Vodafone products and services by tapping on my products',
  tutorial_step2_title: 'Easy to access Services',
  tutorial_step3_description: 'Take charge of your current plan and get the chance to discover further opportunities for better connected living',
  tutorial_step3_title: 'Everything about your plan',
  contact_preferences_card_description: 'Please select the preferred way for us to contact you:',
  contact_preferences_confirm_button_text: 'Confirm',
  contact_preferences_title: 'Contact preferences',
  personal_preferences_advanced_description: 'Sharing data related to behaviour on the internet or habits based on Vodafone\'s traffic and location data and devices\' data',
  personal_preferences_advanced_toggle_title: 'Advanced',
  personal_preferences_basic_description: 'Sharing identification data and information to enable offers with Vodafone and third party',
  personal_preferences_basic_toggle_title: 'Basic',
  personal_preferences_confirm_button: 'Confirm',
  personal_preferences_show_less_text: 'Show less',
  personal_preferences_show_more_text: 'Learn more',
  personal_preferences_title: 'Personalised recommendations',
  privacy_permissions_accept_all_settings: 'Accept all',
  privacy_permissions_accept_all_success_description: 'Your privacy settings have been successfully updated. You can change it in Privacy Settings at any time.',
  privacy_permissions_dashboard_button: 'Return to dashboard',
  privacy_permissions_happy_with_this: 'I am happy with this',
  privacy_permissions_learn_more: 'Learn more',
  privacy_permissions_manage_button: 'Manage privacy settings',
  privacy_permissions_overlay_reject_all_success_modal_description: 'To see personalised recommendations and offers',
  privacy_permissions_overlay_reject_all_success_modal_primary_button: 'Return to dashboard',
  privacy_permissions_overlay_reject_all_success_modal_secondary_button: 'Manage privacy settings',
  privacy_permissions_overlay_reject_all_success_modal_title: 'Privacy permissions turned off',
  privacy_permissions_privacy_policy: 'Privacy policy',
  privacy_permissions_processing: 'Processing…',
  privacy_permissions_read_privacy_policy: 'Read Privacy policy',
  privacy_permissions_reject_all_description: 'To see personalised recommendations and offers, update your preferences in Privacy settings',
  privacy_permissions_reject_all_settings: 'Reject all',
  privacy_permissions_reject_all_title: 'Privacy permissions turned off',
  privacy_permissions_set_settings: 'Set privacy settings',
  privacy_permissions_show_less: 'Show less',
  privacy_settings_accept_all_error_screen_button: 'Try again',
  privacy_settings_accept_all_error_screen_message: 'Unfortunately we were unable to process your request.',
  privacy_settings_accept_all_error_screen_title: 'Something went wrong!',
  privacy_settings_contact_preferences_title: 'Contact preferences',
  privacy_settings_loading_screen_title: 'Processing',
  privacy_settings_quick_action_description: 'Your privacy settings have been successfully updated.',
  privacy_settings_quick_action_primary_button_text: 'Return to dashboard',
  privacy_settings_quick_action_secondary_button_text: 'Back',
  privacy_settings_quick_action_title: 'Congratulations!',
  privacy_settings_third_party_apps_permission_off: 'Off',
  privacy_settings_third_party_apps_permission_on: 'On',
  privacy_settings_third_party_apps_title: 'Third party app tracking',
  privacy_settings_title: 'Privacy settings',
  third_party_tracking_btn: 'Confirm',
  third_party_tracking_essential: 'Essential',
  third_party_tracking_essential_description: 'The app will not be able to function without this tracker',
  third_party_tracking_essential_state: 'On',
  third_party_tracking_title: 'Third party app tracking',
  product_selector_edit_name_quick_action_back: 'Back',
  product_selector_edit_name_quick_action_confirm: 'Confirm',
  product_selector_edit_name_quick_action_error_primary_button_text: 'Back',
  product_selector_edit_name_quick_action_error_title: 'Something went wrong',
  product_selector_edit_name_quick_action_loading_text: 'Updating product name',
  product_selector_edit_name_quick_action_subtitle: 'What would you like to name it?',
  product_selector_edit_name_quick_action_success_primary_button_text: 'Return to Dashboard',
  product_selector_edit_name_quick_action_success_title: 'Product name saved',
  product_selector_edit_name_quick_action_title: 'Name this product',
  product_selector_search_hint: 'Search for product, service or number',
  product_selector_search_no_result_subtitle: 'Try searching for another product / service name or number',
  product_selector_search_no_result_subtitle_suggestion: 'Did you mean %1$s',
  product_selector_search_no_result_title: 'Sorry we didn\'t find any match for your search',
  product_selector_search_result: '%1$s result for %2$s',
  product_selector_search_results: '%1$s results for %2$s',
  add_calls_cancel_button_title: 'Cancel',
  add_calls_choose_amount_title: 'Choose the amount',
  add_calls_choose_occurrence_title: 'Choose occurrence of extra minutes',
  add_calls_confirm_button_title: 'Confirm',
  add_calls_edit_title: 'Edit',
  add_calls_occurrence_first_option_title: 'One off',
  add_calls_occurrence_second_option_title: 'Recurring',
  add_calls_one_off_payment_statement: 'Charges are not added to your monthly bill. You’ll be charged as soon as you top up. This is a one-off charge and will not recur automatically',
  add_calls_payment_method_title: 'Payment method',
  add_calls_payment_success_message: 'You have added %1$@%2$@ extra to your plan and it has been added to your plan.',
  add_data_apple_pay_title: 'Apple pay',
  add_data_buy_offer_button_text: 'Get the offer',
  add_data_buy_offer_confirm_with_payment: 'Buy offer now',
  add_data_buy_offer_confirmation_text: 'Do you want to get the special offer for you of %1$s%2$s for just %3$s%4$s?',
  add_data_buy_offer_discard_with_payment: 'Discard offer',
  add_data_buy_offer_primary_button_text: 'Complete purchase',
  add_data_cancel_button_title: 'Cancel',
  add_data_choose_amount_title: 'Choose the amount',
  add_data_choose_occurrence_title: 'Choose occurrence of extra data',
  add_data_confirm_button_title: 'Confirm',
  add_data_edit_title: 'Edit',
  add_data_occurrence_first_option_title: 'One off',
  add_data_occurrence_second_option_title: 'Recurring',
  add_data_one_off_payment_statement: 'Charges are not added to your monthly bill. You’ll be charged as soon as you top up. This is a one-off charge and will not recur automatically',
  add_data_payment_failure_message: 'Your transaction could not be completed',
  add_data_payment_failure_title: 'Something went wrong',
  add_data_payment_failure_try_again_button_title: 'Try again',
  add_data_payment_method_title: 'Payment method',
  add_data_payment_success_message: 'You have added %1$s%2$s extra to your plan and it has been added to your plan.',
  add_data_payment_success_return_button_title: 'Return to My Plan',
  add_data_payment_success_title: 'Congratulations!',
  add_data_quick_action_loading: 'Processing Payment…',
  add_data_recurring_payment_statement: 'Charges are added to your monthly bill.\nAny un-used data allowance can continue to be used until your plan refreshes.',
  add_data_title: 'Add data to your plan',
  add_member_quick_action_input_label: 'Phone number',
  add_member_quick_action_subtitle: 'Phone number of the member',
  add_member_quick_action_title: 'Add new member',
  add_sms_apple_pay_title: 'Apple pay',
  add_sms_cancel_button_title: 'Cancel',
  add_sms_choose_amount_title: 'Choose the amount',
  add_sms_choose_occurrence_title: 'Choose occurrence of extra SMS',
  add_sms_confirm_button_title: 'Confirm',
  add_sms_edit_title: 'Edit',
  add_sms_occurrence_first_option_title: 'One off',
  add_sms_occurrence_second_option_title: 'Recurring',
  add_sms_one_off_payment_statement: 'Charges are not added to your monthly bill. You’ll be charged as soon as you top up. This is a one-off charge and will not recur automatically',
  add_sms_payment_failure_message: 'Your transaction could not be completed',
  add_sms_payment_failure_title: 'Something went wrong',
  add_sms_payment_failure_try_again_button_title: 'Try again',
  add_sms_payment_method_title: 'Payment method',
  add_sms_payment_success_message: 'You have added %1$s%2$s extra to your plan and it has been added to your plan.',
  add_sms_payment_success_return_button_title: 'Return to My Plan',
  add_sms_payment_success_title: 'Congratulations!',
  add_sms_quick_action_loading: 'Processing Payment…',
  add_sms_recurring_payment_statement: 'Charges are added to your monthly bill. Any un-used SMS allowance can continue to be used until your plan refreshes.',
  add_sms_title: 'Add SMS to your plan',
  addons_active: 'Active',
  addons_buy_modal_failure_primary_button_title: 'Try again',
  addons_buy_modal_failure_secondary_button_title: 'Close',
  addons_buy_modal_failure_subtitle: 'Your addon has not been purchased. Try again.',
  addons_buy_modal_failure_title: 'Something went wrong',
  addons_buy_modal_loading: 'Loading',
  addons_buy_modal_success_primary_button_title: 'View your bundles',
  addons_buy_modal_success_secondary_button_title: 'Close',
  addons_buy_modal_success_subtitle: 'Your addon has been successfully purchased.',
  addons_buy_modal_success_title: 'Congratulations!',
  addons_buy_modal_title: 'Add Bundle to your plan',
  addons_default_addon_period: 'month',
  addons_inactive_status: 'Pause',
  addons_list_section_description: 'Active Add-ons',
  addons_list_section_title: 'My Add-ons',
  addons_list_switch: 'Timeline View',
  addons_not_available: 'You don’t have any active Add-ons. Tap on Buy Add-ons to shop.',
  addons_recommended_title: 'Recommended for you',
  addons_remove_modal_failure_subtitle: 'Your addon has not been removed. Try again.',
  addons_remove_modal_success_subtitle: 'Your addon has been successfully removed.',
  addons_remove_modal_success_title: 'Done!',
  addons_screen_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  addons_screen_title: 'Add-ons',
  addons_screen_try_again: 'Try again',
  addons_show_less: 'Show less',
  addons_show_more: 'Show more',
  addons_sub_text: '%1$s€ per %2$s',
  addons_timeline_current_plan: 'Current plan',
  addons_timeline_section_description: 'Timeline',
  addons_timeline_section_title: 'Active services',
  addons_timeline_switch: 'List',
  addons_timeline_today: 'Today',
  balance_date_filter_date_picker_title: 'Select range',
  balance_date_filter_screen_selected_period: 'Selected period',
  balance_date_filter_screen_subtitle: 'Select the dates for your balance',
  balance_date_filter_screen_title: 'Date range',
  balance_date_filter_screen_view_history: 'View history',
  balance_history_section_title_today: 'Today',
  balance_history_section_title_yesterday: 'Yesterday',
  balance_history_see_all_categories: 'See all',
  balance_history_title: 'Balance history',
  balance_screen_date_filter_clear_button_title: 'Clear',
  balance_screen_date_filter_title: 'Dates',
  balance_screen_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  balance_screen_no_history_subtitle: 'Once you use your phone you’ll be able to view your balance history',
  balance_screen_no_history_title: 'You have no balance history',
  balance_screen_title: 'Balance',
  balance_screen_try_again: 'Try again',
  barring_ask_changes_cancel_button: 'Cancel',
  barring_ask_changes_cancel_button_title: 'Cancel',
  barring_ask_changes_confirmation_button: 'Confirm restriction',
  barring_ask_changes_failure_button_title: 'Try again',
  barring_ask_changes_failure_subtitle: 'An error has occurred. Please try again.',
  barring_ask_changes_failure_title: 'Something went wrong',
  barring_ask_changes_success_button_title: 'Go to Permissions',
  barring_ask_changes_success_subtitle: 'Successful confirmation',
  barring_ask_changes_success_title: 'Success',
  barring_ask_changes_title: 'Restrict permissions',
  barring_screen_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  barring_screen_no_barring_title: 'You have no permissions.',
  barring_screen_title: 'Permissions',
  barring_screen_try_again: 'Try again',
  barring_title: 'Permissions',
  change_device_name_quick_action_cancel_button: 'Cancel',
  change_device_name_quick_action_close_button: 'Close',
  change_device_name_quick_action_input_label: 'Device name',
  change_device_name_quick_action_save_button: 'Save device name',
  change_device_name_quick_action_subtitle: 'What would you like to name it?',
  change_device_name_quick_action_success_description: 'Your device name has been successfully updated',
  change_device_name_quick_action_success_title: 'Congratulations!',
  channels_screen_title: 'Channels',
  cvm_device_name_description: 'Would you like to customise the name of this device to make it easier to recognise?',
  cvm_device_name_dismissed_description: 'You can name this device via ‘Device’ tab at any time.',
  cvm_device_name_primary_button_title: 'Name device',
  cvm_device_name_secondary_button_title: 'Maybe later',
  cvm_device_name_title: 'Name this device',
  default_product_cancel_button_text: 'Cancel',
  default_product_device_name: 'Device name',
  default_product_save_button_text: 'Save',
  default_product_set_default_device: 'Set as default device.',
  default_product_set_default_device_description: 'Make this device default and see all the usage data and balance on the dashboard right after the app starts.',
  default_product_subtitle: 'Rename your device?',
  default_product_title: 'Customise',
  device_card_edit_name: 'Edit',
  device_screen_title: 'Device',
  group_data_plan_accounts_manage: 'Accounts you manage',
  group_data_plan_add_data_btn: 'Add data',
  group_data_plan_add_member: 'Add member',
  group_data_plan_available_assign: 'available to assign',
  group_data_plan_card_available_data_to_assign: 'Available to assign:',
  group_data_plan_current_data_amount_text: 'You now have',
  group_data_plan_cvv_number: 'CVV number',
  group_data_plan_data: 'Data',
  group_data_plan_data_left: '%1$sGB left of %2$sGB',
  group_data_plan_data_left_text: 'left of',
  group_data_plan_extra_to_plan: 'extra to your plan.',
  group_data_plan_group_data_left: 'group data left',
  group_data_plan_increase_mode_modal_description: 'You have added',
  group_data_plan_increase_mode_modal_title: 'Data increased successfully',
  group_data_plan_increase_mode_user_plan: 'extra to %1$s’s plan.',
  group_data_plan_left_of: '%1$s%2$s left of %3$s%4$s',
  group_data_plan_manage_group: 'Manage group',
  group_data_plan_members: '%1$s Members',
  group_data_plan_modal_available_data_to_assign: 'available to assign.',
  group_data_plan_modal_primary_button: 'Close',
  group_data_plan_no_available_info: 'You have no data available to assign. You can add more or reduce data from someone on this plan.',
  group_data_plan_primary_button_title: 'Confirm',
  group_data_plan_reduce_mode_modal_description: 'You have removed',
  group_data_plan_reduce_mode_modal_title: 'Data reduced successfully',
  group_data_plan_reduce_mode_user_plan: 'from %1$s’s plan.',
  group_data_plan_remove: 'Remove',
  group_data_plan_return_to_group_data: 'Return to Group Data',
  group_data_plan_secondary_button_title: 'Cancel',
  group_data_plan_slider_increase_data_card_title: 'Increase data amount',
  group_data_plan_slider_increase_data_title: 'Increase data',
  group_data_plan_slider_reduce_data_card_title: 'Reduce data amount',
  group_data_plan_slider_reduce_data_title: 'Reduce data',
  group_data_plan_title: 'Group data plan',
  group_data_plan_top_up_btn: 'Top-up',
  group_data_plan_used_month: '%1$s%2$s used this month',
  group_data_plan_user_data: '%1$s’s data:',
  group_data_plan_user_phone: '%1$s’s phone',
  group_data_plan_your_plan: 'Your plan',
  manage_addon_action_cancel: 'Cancel',
  manage_addon_action_confirm: 'Confirm',
  manage_addon_action_timeline: 'Timeline view',
  manage_addon_active_addon_title: 'Active Add-ons',
  manage_addon_addons_title: 'My Add-ons',
  manage_addon_buy_action_button_title: 'Buy this Add-on',
  manage_addon_buy_action_title: 'Buy Add-ons',
  manage_addon_buy_confirm_message: 'Are you sure you want to buy %1$s add-on?',
  manage_addon_buy_date_title: 'Starting today',
  manage_addon_buy_more_details: 'You will still be able to start using this add-on from today.',
  manage_addon_buy_quick_action_title: 'Buy Add-on',
  manage_addon_duration: 'per %1$s',
  manage_addon_remove_action_button_title: 'Remove',
  manage_addon_remove_confirm_message: 'Are you sure you want to remove %1$s add-on?',
  manage_addon_remove_date_title: 'Expiration date',
  manage_addon_remove_more_details: 'You will still be able to use this add-on until %1$s',
  manage_addon_remove_quick_action_title: 'Remove Add-on',
  manage_addon_renew_title: 'Auto re-new',
  member_quick_action_cancel: 'Cancel',
  member_quick_action_confirm: 'Confirm',
  my_device_contract_end_date_label: 'You can upgrade for free on',
  my_device_screen_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  my_device_screen_subtitle: 'Device details',
  my_device_screen_title: 'My current device',
  my_device_screen_try_again: 'Try again',
  my_device_show_less: 'Show less',
  my_device_show_more: 'Show more',
  my_device_upgrade_button_title: 'View History',
  my_device_upgrade_offer_label: 'Upgrade today for',
  my_plan_group_data_edit_button: 'Edit group data',
  my_plan_primary_card_consumption: '%1$s left of %2$s',
  my_plan_primary_card_contract_end_label: 'Contract ends on',
  my_plan_primary_card_data: 'Data',
  my_plan_primary_card_data_add_button: 'Add Data',
  my_plan_primary_card_header_renewal_date: 'Renewal date %1$s',
  my_plan_primary_card_local_calls: 'Local calls',
  my_plan_primary_card_local_calls_add_button: 'Add Minutes',
  my_plan_primary_card_minimum_term_end_label: 'Minimum term ends on',
  my_plan_primary_card_price_label: 'Price per month',
  my_plan_primary_card_puk_code_label: 'PUK code',
  my_plan_primary_card_renewal_date_label: 'Renewal date',
  my_plan_primary_card_show_less: 'Show less',
  my_plan_primary_card_show_less_usage: 'Show less',
  my_plan_primary_card_show_more: 'Show more',
  my_plan_primary_card_show_more_usage: 'Show more',
  my_plan_primary_card_sim_number_label: 'SIM card no',
  my_plan_primary_card_sms: 'SMS',
  my_plan_primary_card_sms_add_button: 'Add SMS',
  my_plan_primary_card_subtitle: 'Your plan',
  my_plan_primary_card_subtitle_basic_bundle: 'Basic bundle',
  my_plan_primary_card_title: 'Active services',
  my_plan_primary_card_title_subscription: 'Your subscription',
  my_plan_primary_card_unlimited_consumption: 'Unlimited',
  my_plan_primary_card_upgrade_plan: 'Upgrade plan',
  my_plan_primary_card_upgrade_start_label: 'Eligible to upgrade from',
  my_plan_screen_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  my_plan_screen_title: 'My Plan',
  my_plan_screen_try_again: 'Try again',
  my_products_header_payg_title: 'Your balance',
  my_products_header_payg_topup_button_title: 'Top-up',
  my_products_header_payg_value_appended_text: 'of credit left',
  my_products_header_paym_title: 'Cost per month',
  my_products_header_paym_value_appended_text: 'added to your bill',
  my_products_updatedlabel_justupdated: 'Just updated',
  my_products_updatedlabel_minute: 'Updated %1$s min ago',
  my_products_updatedlabel_minutes: 'Updated %1$s mins ago',
  my_products_updatedlabel_timestamp: 'Updated %1$s',
  my_products_updatedlabel_updating: 'Updating…',
  product_switcher_category_filter_all: 'All',
  remove_member_quick_action_description: '%1$sGB of data will be added to your group data plan.',
  remove_member_quick_action_subtitle: 'Do you want to remove %1$s from your Group data plan?',
  remove_member_quick_action_title: 'Remove member',
  router_screen_title: 'Router',
  secure_net_my_products_protected_status: 'Protected',
  secure_net_my_products_screen_title: 'My products',
  secure_net_my_products_unprotected_status: 'Unprotected',
  shop_addons_my_plan_categories: 'Myplan',
  shop_addons_others_categories: 'Others',
  shop_addons_passes_categories: 'Passes',
  shop_addons_recommended_title: 'Offer just for you',
  shop_addons_screen_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  shop_addons_screen_try_again: 'Try again',
  shop_addons_see_all_categories: 'See all',
  shop_addons_subtitle: 'Add more Add-ons to your mobile phone',
  shop_addons_title: 'Shop Add-ons',
  soho_add_calls_title: 'Add minutes to plan',
  soho_add_data_payment_success_return_button_title: 'Return to plan',
  soho_add_data_title: 'Add Data to plan',
  soho_add_sms_title: 'Add SMS to plan',
  usage_screen_title: 'Usage',
  refer_a_friend_activation_count: '%1$s Successful referrals',
  refer_a_friend_button_share: 'Share link',
  refer_a_friend_copied_message: 'Copied to clipboard',
  refer_a_friend_joined_on: 'Joined on %1$s',
  refer_a_friend_read_terms_and_conditions: 'Read terms and conditions',
  refer_a_friend_refer_more_friends_button: 'Refer more friends',
  refer_a_friend_return_to_dashboard_button: 'Return to dashboard',
  refer_a_friend_share_action: 'Complete action using',
  refer_a_friend_successful_referral_message: 'Great news! %1$s joined Vodafone',
  refer_a_friend_successful_referral_title: 'Successful Referral',
  settings_app_login: 'App login options',
  settings_app_privacy: 'App privacy',
  settings_app_privacy_supplement: 'App privacy supplement',
  settings_display_options: 'Display options',
  settings_edit_dashboard_subtitle: 'You can customize which tiles of your products you want to see on the dashboard.',
  settings_edit_dashboard_title: 'Edit dashboard tiles',
  settings_reset_the_app: 'Reset the app',
  settings_terms_and_conditions: 'Terms and conditions',
  settings_title: 'App Settings',
  settings_useful_information: 'Useful Information',
  auto_bill_quick_action_title: 'Set up auto bill payment',
  auto_top_up_amount_description: 'Once your balance falls below the selected amount, your account will be automatically topped-up.',
  auto_top_up_amount_subtitle: 'When my balance is less than',
  auto_top_up_amount_text: 'Amount',
  auto_top_up_cvm_button_text: 'Set Auto top-up',
  auto_top_up_cvm_description: 'Don\'t worry about running out of credit anymore by setting up a recurring auto top-up.',
  auto_top_up_cvm_title: 'Auto top-up',
  auto_top_up_days_list_friday: 'FR',
  auto_top_up_days_list_monday: 'MO',
  auto_top_up_days_list_saturday: 'SA',
  auto_top_up_days_list_sunday: 'SU',
  auto_top_up_days_list_thursday: 'TH',
  auto_top_up_days_list_tuesday: 'TU',
  auto_top_up_days_list_wednesday: 'WE',
  auto_top_up_edit_cvm_amount_description: 'Your phone will top-up by %1$s€ when your balance is equal to or less than %2$s€.',
  auto_top_up_edit_cvm_button_text: 'Edit auto top-up',
  auto_top_up_edit_cvm_monthly_description: 'Your phone will top-up by %1$s€ on the %2$s of each month. Next top-up in %3$s days.',
  auto_top_up_edit_cvm_title_off: 'Auto top-up is off',
  auto_top_up_edit_cvm_title_on: 'Auto top-up is on',
  auto_top_up_edit_cvm_weekly_description: 'Your phone will top-up by %1$s€ every %2$s. Your next top-up will occur on the %3$s of %4$s.',
  auto_top_up_monthly_description: 'Your balance will be topped up on the selected day of every month. If this date does not fall within the month, your balance will be topped up on the 1st of the next month.',
  auto_top_up_monthly_subtitle: 'Select the day of the month',
  auto_top_up_monthly_text: 'Monthly',
  auto_top_up_quick_action_button_text: 'Set auto top-up',
  auto_top_up_quick_action_cancel_button: 'Cancel',
  auto_top_up_quick_action_edit_button_text: 'Edit auto top-up',
  auto_top_up_quick_action_edit_loading: 'Editing auto top-up…',
  auto_top_up_quick_action_edit_title: 'Edit auto top-up',
  auto_top_up_quick_action_failure_description: 'Unfortunately we were unable to process your request. Please review your payment details.',
  auto_top_up_quick_action_failure_primary_button_text: 'Try again',
  auto_top_up_quick_action_failure_secondary_button_text: 'Go back',
  auto_top_up_quick_action_failure_title: 'Something went wrong!',
  auto_top_up_quick_action_loading: 'Setting up your auto top-up…',
  auto_top_up_quick_action_next_button: 'Next',
  auto_top_up_quick_action_subtitle: 'Choose occurrence of the top-up',
  auto_top_up_quick_action_success_amount_description: 'You will top-up by %1$s€ when your balance is equal to or less than %2$s€.',
  auto_top_up_quick_action_success_monthly_description: 'You will top-up by %1$s€ on the %2$s of each month.',
  auto_top_up_quick_action_success_primary_button_text: 'Done',
  auto_top_up_quick_action_success_title: 'Your auto top-up is set!',
  auto_top_up_quick_action_success_weekly_description: 'Your balance will automatically be topped up by %1$s€ every %2$s.',
  auto_top_up_quick_action_title: 'Set auto top-up',
  auto_top_up_week_days_friday: 'friday',
  auto_top_up_week_days_monday: 'monday',
  auto_top_up_week_days_saturday: 'saturday',
  auto_top_up_week_days_sunday: 'sunday',
  auto_top_up_week_days_thursday: 'thursday',
  auto_top_up_week_days_tuesday: 'tuesday',
  auto_top_up_week_days_wednesday: 'wednesday',
  auto_top_up_weekly_description: 'Your balance will be topped up on the selected day of every week.',
  auto_top_up_weekly_subtitle: 'Select the day of the week',
  auto_top_up_weekly_text: 'Weekly',
  contacts_permission_alert_cancel_title: 'Cancel',
  contacts_permission_alert_confirm_title: 'Settings',
  contacts_permission_alert_message: 'To view your contacts you need to give My Vodafone permission to access your contacts in Settings.',
  contacts_permission_alert_title: 'Update your settings',
  custom_auto_top_up_field_currency: '€',
  custom_auto_top_up_field_hint: 'Add custom amount',
  custom_auto_top_up_field_lower_hint: 'Your top up should not exceed %1$s %2$s',
  custom_auto_top_up_field_lower_hint_error: 'You have exceeded the amount limit of %1$s %2$s',
  custom_auto_top_up_field_upper_hint: 'Custom amount',
  custom_auto_top_up_first_tab: 'Quick top-up',
  custom_auto_top_up_second_tab: 'Custom amount',
  custom_auto_top_up_success_button: 'Return to My Dashboard',
  custom_auto_top_up_success_message: 'You have added %1$s to your phone and it has been added to your balance.',
  custom_auto_top_up_success_title: 'Congratulations!',
  dashboard_top_up_card_badge_unpaid_title: 'Load amount',
  dashboard_top_up_card_date_paid_title: 'Load amount',
  dashboard_top_up_card_description_unpaid_title: 'Couldn\'t renew tariff',
  dashboard_top_up_card_due_in_days: 'Due in %1$s days',
  dashboard_top_up_card_last_updated: 'Updated %1$@ ago',
  dashboard_top_up_card_subtitle: 'Your current credit is:',
  dashboard_top_up_card_title: 'Top-up',
  dashboard_top_up_card_username: '%1$s\'s phone',
  dashboard_top_up_item_title: 'Top-up',
  quick_action_add_new_payment_card_done: 'Done',
  quick_action_add_new_payment_card_encryption_hint: 'This is a secure SSL encrypted channel. Your card details are associated with your Vodafone ID',
  quick_action_add_new_payment_card_expiration_date_hint_message: 'MM/YY',
  quick_action_add_new_payment_card_field_card_name: 'Name this card',
  quick_action_add_new_payment_card_field_card_name_error_message: 'Invalid card name',
  quick_action_add_new_payment_card_field_card_number: 'Card number',
  quick_action_add_new_payment_card_field_card_number_error_message: 'Invalid card number',
  quick_action_add_new_payment_card_field_cvv: 'CVV',
  quick_action_add_new_payment_card_field_cvv_error_message: 'Invalid CVV number',
  quick_action_add_new_payment_card_field_expire_date: 'Expiry date',
  quick_action_add_new_payment_card_field_expire_date_error_message: 'Invalid date',
  quick_action_add_new_payment_card_field_name_on_card: 'Name on card',
  quick_action_add_new_payment_card_field_name_on_card_error_message: 'Invalid name on card',
  quick_action_add_new_payment_card_save_this_card: 'Save this card for later use',
  quick_action_add_new_payment_card_subtitle: 'Enter the card details',
  quick_action_add_new_payment_card_title: 'New credit/debit card',
  quick_action_add_new_payment_temp_card_name: 'Temporary Card',
  sub_tray_my_phone_title: 'My Phone',
  top_up_data_added_successful: 'Data added!',
  top_up_quick_action_accepting_offer_subtitle: 'Normal price %1$s%2$s. Offer ends on %3$s.',
  top_up_quick_action_add_data_button_text: 'Add data',
  top_up_quick_action_add_data_label_text: 'Add %1$s%2$s for %3$s%4$s?',
  top_up_quick_action_add_data_normal_price: 'Normal price %1$s%2$s',
  top_up_quick_action_add_payment_method_item_text: 'Add new',
  top_up_quick_action_back_button_text: 'Back',
  top_up_quick_action_balance: 'You have added %1$s%2$s to your phone and it has been added to your balance.',
  top_up_quick_action_balance_and_data_added_remaining: 'Your purchase was completed successfully. Your balance is now %1$s%2$s and you now have %3$s%4$s GB of data remaining',
  top_up_quick_action_balance_and_remaining: 'Your balance is now %1$s%2$s and you have %3$s%4$s left.',
  top_up_quick_action_balance_offer: 'Your purchase was completed successfully. Your balance is now %1$s%2$s and you now have %3$s%4$s of data remaining',
  top_up_quick_action_close_button_text: 'Close',
  top_up_quick_action_confirm_button_text: 'Top-up now',
  top_up_quick_action_currency: '€',
  top_up_quick_action_data_added_remaining: 'Your purchase was completed successfully. You now have %1$s%2$s of data remaining',
  top_up_quick_action_edit: 'Edit',
  top_up_quick_action_error_button: 'Try again',
  top_up_quick_action_error_message: 'An error has occurred and we’re having some trouble loading your content.',
  top_up_quick_action_loading: 'Processing Payment…',
  top_up_quick_action_loading_main: 'Processing top-up…',
  top_up_quick_action_loading_purchase: 'Processing purchase…',
  top_up_quick_action_main_title: 'Top-up my phone',
  top_up_quick_action_no_offer_button: 'No thanks, %1$s%2$s is fine',
  top_up_quick_action_no_thanks_button_text: 'No, thanks',
  top_up_quick_action_offer: 'If you top-up by %1$s%2$s you can get %3$s%4$s of %5$s for only %6$s%7$s.',
  top_up_quick_action_offer_button: 'Top up %1$s%2$s instead',
  top_up_quick_action_offer_completed: 'Top up completed and offer unlocked!',
  top_up_quick_action_offer_end: 'Offer ends on Thursday.',
  top_up_quick_action_offer_subtitle: 'Top up by %1$s%2$s or more and you can get %3$s%4$s of %5$s for only %6$s%7$s.',
  top_up_quick_action_offer_summary_data_title: '%1$s%2$s data',
  top_up_quick_action_offer_summary_title: 'Payment Summary',
  top_up_quick_action_offer_summary_top_up_title: 'Top-up',
  top_up_quick_action_offer_summary_total_title: 'Total',
  top_up_quick_action_offer_title: 'Add %1$s%2$s of data for only %3$s',
  top_up_quick_action_offer_value: 'Your balance is now %1$s%2$s. You can add %3$s%4$s for just %5$s%6$s getting this special offer for you.',
  top_up_quick_action_ok_button_text: 'OK',
  top_up_quick_action_payment_method_title: 'Payment method',
  top_up_quick_action_remove_data_button_text: 'Remove',
  top_up_quick_action_return_to_dashboard_button_text: 'Return to My Dashboard',
  top_up_quick_action_selected_payment_method_desc: '**** **** **** %1$s',
  top_up_quick_action_set_auto_topup_button_text: 'Set Auto top-up',
  top_up_quick_action_single_offer_subtitle: 'Top up by %1$s%2$s and you can get %3$s%4$s of %5$s for only %6$s%7$s',
  top_up_quick_action_subtitle: 'Select the amount',
  top_up_quick_action_successful: 'Congratulations!',
  top_up_quick_action_title: 'Top-up %1$s\'s phone',
  top_up_quick_action_upgrade_top_up_subtitle: 'Normal price %1$s%2$s.\nOffer ends on %3$s.',
  top_up_someone_else_contact_list_search_bar_placholder: 'Search contact',
  top_up_someone_else_contact_list_section_all_title: 'All',
  top_up_someone_else_contact_list_section_recent_title: 'Recent',
  top_up_someone_else_contact_list_section_title: 'Select a contact',
  top_up_someone_else_default_tab_title: 'Quick top-up',
  top_up_someone_else_new_recipient_error_title: 'Invalid phone number',
  top_up_someone_else_new_recipient_header_title: 'Mobile number',
  top_up_someone_else_new_recipient_keyboard_done_text: 'Done',
  top_up_someone_else_new_recipient_placeholder: 'Mobile number',
  top_up_someone_else_new_recipient_title: 'New recipient',
  top_up_someone_else_next_button_title: 'Next',
  top_up_someone_else_quick_action_failure_description: 'Unfortunately we were unable to process your request. Please review your payment details.',
  top_up_someone_else_quick_action_failure_primary_button_text: 'Try again',
  top_up_someone_else_quick_action_failure_secondary_button_text: 'Go back',
  top_up_someone_else_quick_action_failure_title: 'Something went wrong!',
  top_up_someone_else_quick_action_subtitle: 'My phone',
  top_up_someone_else_quick_action_title: 'Top-up',
  top_up_someone_else_quick_action_title_with_formatting: 'Top-up %1$s',
  top_up_someone_else_section_title: 'Select the recipient',
  top_up_someone_else_successful_description: 'You have added %1$s%2$s to %3$s and this has been added to their balance.',
  top_up_someone_else_successful_primary_button_text: 'Return to My Dashboard',
  top_up_someone_else_successful_title: 'Congratulations!',
  expanded_tray_header_button_text: 'Manage Group',
  expanded_tray_header_text: 'Group Data',
  sub_tray_access_secure_content_subtitle: 'Tap to access this secure area',
  sub_tray_accounts_section_title: 'Account',
  sub_tray_all_category: 'All (%1$s)',
  sub_tray_broadband_subtitle: 'One Kingdom St',
  sub_tray_broadband_title: 'Broadband',
  sub_tray_change_password_subtitle: 'Change password',
  sub_tray_change_password_title: 'My password',
  sub_tray_customization_cancel_button_title: 'Cancel',
  sub_tray_customization_customize_title: 'Customise',
  sub_tray_customization_device_name_hint_title: 'Device name',
  sub_tray_customization_device_name_placeholder_title: 'Device name',
  sub_tray_customization_rename_device_title: 'Rename your device?',
  sub_tray_customization_save_button_title: 'Save',
  sub_tray_customization_set_default_device_subtitle: 'Make this device default and see all the usage data and balance on the dashboard right after the app starts.',
  sub_tray_customization_set_default_device_title: 'Set as default device.',
  sub_tray_empty_title: 'There are no items for %1$s',
  sub_tray_error_try_again_button: 'Try again',
  sub_tray_item_customize: 'Customise',
  sub_tray_item_recommended_view: 'Recommended',
  sub_tray_my_orders_subtitle_no_order: 'No order in progress',
  sub_tray_my_orders_subtitle_with_one_order: '%1$s new update',
  sub_tray_my_orders_subtitle_with_orders: '%1$s new updates',
  sub_tray_my_orders_title: 'My orders',
  sub_tray_my_phone_subtitle: '+34 670 83 78 50',
  sub_tray_my_products_title: 'My Products',
  sub_tray_payment_subtitle: '%1$s methods available',
  sub_tray_payment_subtitle_one_method: '1 method available',
  sub_tray_payment_subtitle_zero_method: '0 payment methods',
  sub_tray_payment_title: 'Payment',
  sub_tray_search_hint: 'Search',
  sub_tray_select_one: 'Select one',
  sub_tray_sub_title: 'Open',
  sub_tray_v_home_subtitle: 'Brighton house',
  sub_tray_v_home_title: 'V-Home',
  sub_tray_v_home_two_subtitle: 'London apartment',
  sub_tray_v_home_two_title: 'V-Home',
  sub_tray_verification_change_default: 'You changed your default device successfully.',
  sub_tray_verification_confirmation_title: 'Confirmation',
  sub_tray_verification_default_number_confirmation: 'Do you confirm the change of the favorite number from %1$s to %2$s?',
  sub_tray_verification_enter_sms: 'Enter the SMS code',
  sub_tray_verification_loading_text: 'Confirming changes…',
  sub_tray_verification_overlay_primary_button: 'OK',
  sub_tray_verification_overlay_secondary_button: 'Cancel',
  sub_tray_verification_overlay_title: 'Set default device',
  sub_tray_verification_receive_sms: 'You will receive an SMS confirmation code to set this device as default',
  sub_tray_verification_return_to_dashboard: 'Return to My Dashboard',
  sub_tray_verification_set_default_primary_button: 'Confirm',
  sub_tray_verification_set_default_secondary_button: 'Cancel',
  sub_tray_verification_set_default_title: 'Set default device',
  sub_tray_verification_sms_confirmation_description: 'An SMS has been sent with the confirmation code to %1$s',
  sub_tray_verification_transaction_successful: 'Transaction successful',
  switch_account_button_title: 'Switch accounts',
  switch_account_quick_action_add_an_account_button_title: 'Add an account',
  switch_account_quick_action_cancel_button_title: 'Cancel',
  switch_account_quick_action_current_account_title: 'Current account',
  switch_account_quick_action_header_title: 'Switch accounts',
  switch_account_quick_action_manage_accounts_on_device: 'Manage accounts on this device',
  switch_account_quick_action_more_account_title: 'Accounts',
  switch_account_quick_action_one_account_title: 'See account',
  switch_account_quick_action_other_accounts_title: 'Other accounts',
  switch_account_quick_action_title: 'Switch accounts',
  tray_accounts_section_title: 'Account',
  tray_more_item_quick_action_title: 'More options',
  tray_my_products_section_title: 'My Products',
  tray_offers_and_rewards_section_title: 'Offers & rewards',
  tray_offers_title: 'Offers',
  tray_rewards_title: 'Rewards',
  tray_tobi_message: 'Let me know if I can help you.',
  tray_top_up_section_title: 'Top-up',
  dashboard_basic_group_and_sos_component_name: 'Basics & SOS Services',
}
